import api from './api';

const processingStepsService = {
  list: async () => {
    const response = await api.get('/admin/processing-steps');
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/admin/processing-steps/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/admin/processing-steps', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/admin/processing-steps/${id}`, data);
    return response.data;
  },

  remove: async (id) => {
    const response = await api.delete(`/admin/processing-steps/${id}`);
    return response.data;
  },

  // ── Settings (processingstepsettings) ──────────────────────────────────────
  listSettings: async (stepId) => {
    const response = await api.get(`/admin/processing-steps/${stepId}/settings`);
    return response.data;
  },

  createSetting: async (stepId, data) => {
    const response = await api.post(`/admin/processing-steps/${stepId}/settings`, data);
    return response.data;
  },

  updateSetting: async (stepId, settingId, data) => {
    const response = await api.put(`/admin/processing-steps/${stepId}/settings/${settingId}`, data);
    return response.data;
  },

  removeSetting: async (stepId, settingId) => {
    const response = await api.delete(`/admin/processing-steps/${stepId}/settings/${settingId}`);
    return response.data;
  }
};

export default processingStepsService;
